// removed by extract-text-webpack-plugin
module.exports = {"whyus":"src-components-WhyUs----whyus-module---whyus---1tpIZ","column":"src-components-WhyUs----whyus-module---column---2TAIR","about":"src-components-WhyUs----whyus-module---about---360uQ","icon":"src-components-WhyUs----whyus-module---icon---38tSh","title":"src-components-WhyUs----whyus-module---title---2EZjW","main":"src-components-WhyUs----whyus-module---main---1slEV","fb":"src-components-WhyUs----whyus-module---fb---3Rr9H","headline":"src-components-WhyUs----whyus-module---headline---3gGuH","img":"src-components-WhyUs----whyus-module---img---2OLeS"};


//////////////////
// WEBPACK FOOTER
// ./src/components/WhyUs/whyus.module.css
// module id = 680
// module chunks = 35783957827783